import customerGroups, { CustomerGroupConfig, CustomerGroupId } from "../config/customer-groups";

import { assert } from "./assert";

export const getCustomerGroupConfig = (id: CustomerGroupId): CustomerGroupConfig => {
  const customerGroup = customerGroups.find(group => group.id === id);
  assert(customerGroup, `Customer group with id ${id} not found`);
  return customerGroup;
};
